const base64url = (bytes) =>
    btoa(String.fromCharCode(...bytes))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

// 32 bytes as base64url is 43 characters, the minimum RFC 7636 allows for a code verifier.
export const randomSecret = () => {
    const bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);

    return base64url(bytes);
};

export const computeChallenge = async (verifier) => {
    const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));

    return base64url(new Uint8Array(digest));
};
